// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"22948ffaceb2e5ef7750","655":"a02fa0d2bd666ac513e7"}[chunkId] + ".js";
};